// extracted by mini-css-extract-plugin
module.exports = {"container":"full-body_container__hYbOo","image":"full-body_image__avuzf"};